/**
 * Единый список имён параметров фракционирования (store / шапка), не из таблицы модели.
 */
export const FRACTIONATION_PARAM_NAMES = [
  'totalDose',
  'total_absorbed_dose',
  'dose_per_fraction',
  'number_of_fractions',
  'n_f',
];

export const FRACTIONATION_INPUT_ERROR =
  'Задайте параметры фракционирования: доза на сеанс d, число сеансов nf и суммарная доза D должны быть больше нуля.';

export const SETUP_PLAN_REQUIRED =
  'Выберите файл из списка ранее загруженных или загрузите новый файл ГДО.';

function isPositiveNumber(v) {
  const n = Number(v);
  return Number.isFinite(n) && n > 0;
}

/**
 * Проверка полей формы до нормализации (nf=0 не превращается в 1).
 * @param {{ dose_per_fraction?: number|null, number_of_fractions?: number|null }|null|undefined} form
 */
export function validateFractionationForm(form) {
  const d = form?.dose_per_fraction;
  const nf = form?.number_of_fractions;
  if (!isPositiveNumber(d) || !isPositiveNumber(nf)) {
    return { ok: false, error: FRACTIONATION_INPUT_ERROR };
  }
  const total = Number(d) * Number(nf);
  if (!isPositiveNumber(total)) {
    return { ok: false, error: FRACTIONATION_INPUT_ERROR };
  }
  const dosePerFraction = Number(d);
  const numberOfFractions = Number(nf);
  return {
    ok: true,
    dose_per_fraction: dosePerFraction,
    number_of_fractions: numberOfFractions,
    total_absorbed_dose: total,
    /** @deprecated alias — используйте total_absorbed_dose */
    totalDose: total,
    /** @deprecated alias — используйте number_of_fractions */
    n_f: numberOfFractions,
  };
}

/**
 * @param {{ total_absorbed_dose?: number|null, dose_per_fraction?: number|null, number_of_fractions?: number|null }|null|undefined} fractionation
 */
export function validateFractionationInput(fractionation) {
  return validateFractionationForm({
    dose_per_fraction: fractionation?.dose_per_fraction,
    number_of_fractions: fractionation?.number_of_fractions,
    total_absorbed_dose: fractionation?.total_absorbed_dose,
  });
}
